import React from "react";

import {CircularProgress} from "@mui/joy";

// components
import UserSubscriberContext from "../../context/UserSubscriberContext";
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import withRouter from "../../utils/withRouter";
import retrievePermission from "../../utils/retrievePermission";
import PresentationCard from "./PresentationCard";
import PresentationUploadModal from "./PresentationUploadModal";


class PresentationList extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            presentations: null,
            pages: null,
            updatePermission: 0,
            uploadPermission: 0,
            deletePermission: 0,
        };
    }

    async componentDidMount() {
        await this.retrievePresentations();
        await this.retrievePermission();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrievePresentations();
        }
    }

    async retrievePresentations(){
        const api = new BaseApi();
        let url = 'presentation';
        let params = {};
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        let response = await api.get(
            url,
            params
        );
        this.setState(
            {
                presentations: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }

    async retrievePermission() {
        let updatePermission = await retrievePermission(
            'PresentationViewSet',
            'partial_update',
            this.context.subscriberObject
        );
        let uploadPermission = await retrievePermission(
            'PresentationViewSet',
            'upload',
            this.context.subscriberObject
        );
        let deletePermission = await retrievePermission(
            'PresentationViewSet',
            'destroy',
            this.context.subscriberObject
        );
        await this.setState(
            {
                updatePermission: updatePermission,
                uploadPermission: uploadPermission,
                deletePermission: deletePermission,
            }
        );
    }

    render() {
         if (!this.state.presentations || !this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <CommonPaginatedComponentList
                title={this.props.title}
                pages={this.state.pages}
                pageNumber={this.state.pageNumber}
                url={'marketing/presentation/'}
                data={this.state.presentations}
                component={PresentationCard}
                componentKeyword={'presentation'}
                componentProps={{

                }}
                paginationCallback={this.retrievePresentations.bind(this)}
                callBack={this.retrievePresentations.bind(this)}
                extraComponents={[
                    ...this.state.uploadPermission?[
                    {
                        component: PresentationUploadModal,
                        componentProps: {
                        },
                        callBack: this.retrievePresentations.bind(this),
                    }
                    ]:[],
                ]}
            />
        )
    }
}

export default withRouter(PresentationList)